import React, { useEffect, useState } from 'react';
import Dashboard from 'components/Layout/Dashboard/Dashboard';
import CaseComponent from 'components/Cases/CaseComponent';
import api from 'api';

const CasePage = () => {
  const [advisers, setAdvisers] = useState([] as any);

  useEffect(() => {
    api.getFirmUsers().then(({ data }: any) => {
      setAdvisers(
        data.results
          .filter((user: any) => user.access_level === 'Adviser')
          .map((user: any) => ({
            name: user.full_name,
            value: user.id
          }))
      );
    });
  }, []);

  return (
    <Dashboard>
      <CaseComponent advisers={advisers} />
    </Dashboard>
  );
};

export default CasePage;
